import React from "react";

import Hero from "./AllocatorHero"
import WhatYouGet from "./WhatYouGet";
import WhoItIsFor from "./WhoItIsFor";
import Timeline from "./Timeline";

import Fees from "./Fees";



import Contact from "../common/Contact";
import Footer from "../common/Footer";

const Allocators = () => {
  return (
    <>

      {/* Content */}
      <Hero/>
      <WhatYouGet />
      <WhoItIsFor />
      <Timeline />
    
      <Fees />
      <Contact />
      <Footer />
    </>
  );
};

export default Allocators;
